<template>

<div class="container-wrapper">

    <div class="vertical-spacer"></div>

    <div class="full-width">

      <kpisIndicators />

    </div>

    <div class="vertical-spacer"></div>

    <div class="full-width">
          <div class="grid grid-3">
              <div class="box-section chart-section-state">
                  <portfolioHealth :interval-chart="5000"/>
              </div>
              <div class="box-section chart-section-state">
                  <regularDensity />
              </div>
              <div class="box-section chart-section-state">
                  <manualsDensity />
              </div>
          </div>
    </div>

    <div class="vertical-spacer"></div>

    <div class="full-width">
      <div class="grid grid-2">
        <div><activeOrders /></div>
        <div><timelineExecutions /></div>
      </div>
    </div>

    <div class="vertical-spacer"></div>

    <div class="full-width">
      <div class="col-3 left-float"><inventoryLedger /></div>
      <div class="col-1 right-float"><profitSummary /></div>
    </div>

</div>

</template>

<script>
import kpisIndicators from '../components/kpisIndicators.vue'
//import rebuySellsDensity from '../components/rebuySellsDensity.vue'
import regularDensity from '../components/regularDensity.vue'
import manualsDensity from '../components/manualsDensity.vue'
import activeOrders from '../components/activeOrders.vue'
import inventoryLedger from '../components/inventoryLedger.vue'
import timelineExecutions from '../components/timelineExecutions.vue'
import portfolioHealth from '../components/portfolioHealth.vue'
import profitSummary from '../components/profitSummary.vue'

export default {
  name: 'StateView',
  components: { regularDensity, kpisIndicators, manualsDensity, activeOrders, inventoryLedger, timelineExecutions, portfolioHealth, profitSummary},
}
</script>

<style>

.chart-section-state {
  height: 460px !important;
}

</style>
